import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { ItemRestrictionsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ItemRestrictionsRule/ItemRestrictionsRuleHeader/ItemRestrictionsRuleHeader';
import { ItemRestrictionsRuleBody } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ItemRestrictionsRule/ItemRestrictionsRuleBody/ItemRestrictionsRuleBody';

export type ItemRestrictionsRuleProps = Omit<AccordionProps, 'header' | 'body'>;

export function ItemRestrictionsRule({
  ...props
}: ItemRestrictionsRuleProps): JSX.Element {
  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <ItemRestrictionsRuleHeader isActive={isActive} />
      )}
      body={(): JSX.Element => <ItemRestrictionsRuleBody />}
    />
  );
}
